import React from 'react';
import { Close } from '@velocity-exchange/icons';
import IconButton, {
	IconButtonProps,
} from 'src/components/primitives/IconButton/IconButton';
import { SetOptional } from 'type-fest';

type Props = Omit<
	SetOptional<IconButtonProps, 'size' | 'variant'>,
	'icon' | 'children'
>;

export default function XButton({
	size = 'lg',
	variant = 'tertiary',
	...props
}: Props) {
	return <IconButton size={size} variant={variant} icon={Close} {...props} />;
}
